"use strict";
/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.GeoPointLocation$ = exports.GeoPointLocation$outboundSchema = exports.GeoPointLocation$inboundSchema = void 0;
exports.geoPointLocationToJSON = geoPointLocationToJSON;
exports.geoPointLocationFromJSON = geoPointLocationFromJSON;
const z = __importStar(require("zod"));
const schemas_js_1 = require("../../../lib/schemas.js");
const coordinates_js_1 = require("./coordinates.js");
const coordinatetype_js_1 = require("./coordinatetype.js");
/** @internal */
exports.GeoPointLocation$inboundSchema = z.object({
    coordinates: z.nullable(coordinates_js_1.Coordinates$inboundSchema),
    type: z.nullable(coordinatetype_js_1.CoordinateType$inboundSchema),
});
/** @internal */
exports.GeoPointLocation$outboundSchema = z.object({
    coordinates: z.nullable(coordinates_js_1.Coordinates$outboundSchema),
    type: z.nullable(coordinatetype_js_1.CoordinateType$outboundSchema),
});
/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
var GeoPointLocation$;
(function (GeoPointLocation$) {
    /** @deprecated use `GeoPointLocation$inboundSchema` instead. */
    GeoPointLocation$.inboundSchema = exports.GeoPointLocation$inboundSchema;
    /** @deprecated use `GeoPointLocation$outboundSchema` instead. */
    GeoPointLocation$.outboundSchema = exports.GeoPointLocation$outboundSchema;
})(GeoPointLocation$ || (exports.GeoPointLocation$ = GeoPointLocation$ = {}));
function geoPointLocationToJSON(geoPointLocation) {
    return JSON.stringify(exports.GeoPointLocation$outboundSchema.parse(geoPointLocation));
}
function geoPointLocationFromJSON(jsonString) {
    return (0, schemas_js_1.safeParse)(jsonString, (x) => exports.GeoPointLocation$inboundSchema.parse(JSON.parse(x)), `Failed to parse 'GeoPointLocation' from JSON`);
}
//# sourceMappingURL=geopointlocation.js.map